import { Icon } from '@aibees/shared/components';
import { Box, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DragDropContext } from 'react-beautiful-dnd';

export const Wrapper = styled(DragDropContext)``;

export const List = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;

  &.Loading {
    opacity: 0.2;
  }
`;

export const Item = styled(Stack)`
  padding: ${(p) => p.theme.spacing(0.5)} 0;
  gap: ${(p) => p.theme.spacing(1)};
  border: 1px dashed transparent;

  &[style~='position:'] {
    top: auto !important;
    left: auto !important;
    background-color: ${(p) => p.theme.palette.background.neutral};
    border-color: ${(p) => p.theme.palette.divider};
  }
`;

export const Handler = styled(Icon)`
  color: ${(p) => p.theme.palette.grey[400]};
  fill: ${(p) => p.theme.palette.grey[500]};
  &:hover {
    color: ${(p) => p.theme.palette.common.black};
  }
`;
